import PrevButton from "./PrevButton";

export default PrevButton;
